import { track } from '@vercel/analytics';

/** Vercel Web Analytics custom events (string | number | boolean values only). */
export function trackEvent(name, data) {
  try {
    const props = sanitizeProps(data);
    if (props) track(name, props);
    else track(name);
  } catch { /* analytics optional */ }
}

function sanitizeProps(data) {
  if (!data || typeof data !== 'object') return undefined;
  const out = {};
  for (const [key, value] of Object.entries(data)) {
    if (value == null) continue;
    const kind = typeof value;
    if (kind === 'string' || kind === 'number' || kind === 'boolean') {
      out[key] = value;
    } else {
      out[key] = String(value);
    }
  }
  return Object.keys(out).length ? out : undefined;
}

/** Clicks through to usepolyvox.com (utm_content = placement). */
export const POLYVOX_EVENT = 'polyvox_click';

/** Custom event names for Langle — filter by these in Vercel → Analytics → Events. */
export const LANGLE_EVENTS = {
  VIEW: 'langle_view',
  LISTEN: 'langle_listen',
  REPLAY: 'langle_replay',
  GUESS: 'langle_guess',
  COMPLETE: 'langle_complete',
  SHARE: 'langle_share',
  HELP: 'langle_help',
  STATS: 'langle_stats',
  GROUP_OPEN: 'langle_group_open',
  GROUP_CREATE: 'langle_group_create',
};

export function trackLangle(event, props) {
  trackEvent(event, props);
}
